import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddCountry, Country } from '../models/country/country';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(
    private _http: HttpClient
  ) { }

    public getCountrys(CountryId?: number): Observable<Country[]>{
        return this._http.get<Country[]>(`${environment.api.url}/Countries?CountriesId=${CountryId??''}`);
    }
  
    public deleteCountry(CountryId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/Countries/${CountryId}`);
    }
  
    public addCountry(model: AddCountry): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/Countries`, model);
    }
}
